// extracted by css-extract-rspack-plugin
export default {"root":"jRMoQ","main":"bMd0N","table":"l_N3W"};